import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderTrustedMarkdown } from '~/functions/markdown';
import { useVentureId } from '~/functions/accounts';
import { useGetImpactGoalQuery, useGetSectionWithQuestionsQuery, TemplateEngineContext, useGetAccountQuery, AccountCategory } from '~/types/types';
import { IMPACT_SECTION_IDS } from '~/constants/impactSectionIds';
import { IMPACT_STRATEGY_CONCEPT_ID } from '~/constants/concepts';
import { canEditImpact, useRealUserIsIxAdmin } from '~/functions/impact-locking';
export default /*#__PURE__*/_defineComponent({
  __name: 'impactStrategy',
  setup: function setup(__props) {
    var SECTION_ID = IMPACT_SECTION_IDS.strategyImpactStrategy;
    var ventureId = useVentureId();
    var _useGetAccountQuery = useGetAccountQuery({
        id: ventureId
      }),
      ventureResult = _useGetAccountQuery.result;
    var venture = computed(function () {
      var _ventureResult$value$, _ventureResult$value;
      return (_ventureResult$value$ = (_ventureResult$value = ventureResult.value) === null || _ventureResult$value === void 0 ? void 0 : _ventureResult$value.getAccount) !== null && _ventureResult$value$ !== void 0 ? _ventureResult$value$ : {
        website: '',
        type: AccountCategory.Venture
      };
    });
    var _useGetImpactGoalQuer = useGetImpactGoalQuery({
        ventureId: ventureId.value
      }),
      result = _useGetImpactGoalQuer.result;
    var impactGoal = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getImpactGoal) || {};
    });
    var tocImpact = computed(function () {
      var _impactGoal$value, _impactGoal$value$imp;
      return impactGoal === null || impactGoal === void 0 ? void 0 : (_impactGoal$value = impactGoal.value) === null || _impactGoal$value === void 0 ? void 0 : (_impactGoal$value$imp = _impactGoal$value.impacts) === null || _impactGoal$value$imp === void 0 ? void 0 : _impactGoal$value$imp.find(function (e) {
        return e.conceptId === IMPACT_STRATEGY_CONCEPT_ID;
      });
    });
    var realUserIsIxAdmin = useRealUserIsIxAdmin();
    var tocImpactEditable = computed(function () {
      return canEditImpact(tocImpact.value, realUserIsIxAdmin.value);
    });
    var _useGetSectionWithQue = useGetSectionWithQuestionsQuery(computed(function () {
        var input = {
          id: SECTION_ID
        };
        return input;
      }), computed(function () {
        return {
          enabled: true
        };
      }) // always enabled since we have hardcoded values
      ),
      sectionResult = _useGetSectionWithQue.result,
      getSectionLoading = _useGetSectionWithQue.loading;
    var section = computed(function () {
      var _sectionResult$value;
      return ((_sectionResult$value = sectionResult.value) === null || _sectionResult$value === void 0 ? void 0 : _sectionResult$value.getSection) || null;
    });
    var showHelp = ref(false);
    return {
      __sfc: true,
      SECTION_ID: SECTION_ID,
      ventureId: ventureId,
      ventureResult: ventureResult,
      venture: venture,
      result: result,
      impactGoal: impactGoal,
      tocImpact: tocImpact,
      realUserIsIxAdmin: realUserIsIxAdmin,
      tocImpactEditable: tocImpactEditable,
      sectionResult: sectionResult,
      getSectionLoading: getSectionLoading,
      section: section,
      showHelp: showHelp,
      renderTrustedMarkdown: renderTrustedMarkdown,
      TemplateEngineContext: TemplateEngineContext
    };
  }
});